import { TokenGenerationEffect } from './token-generation.effect';

export const effects: any[] = [
  TokenGenerationEffect
];
